// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Policy-textfield .input-label {
  font-size: 14px;
}
.Policy-textfield .css-9ddj71-MuiInputBase-root-MuiOutlinedInput-root {
  width: 200px;
  background-color: white;
}
.Policy-textfield .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input {
  height: 0px !important;
}`, "",{"version":3,"sources":["webpack://./src/shared-component/PoliciesDropdown/style.scss"],"names":[],"mappings":"AACI;EACI,eAAA;AAAR;AAEI;EACI,YAAA;EACA,uBAAA;AAAR;AAEI;EACI,sBAAA;AAAR","sourcesContent":[".Policy-textfield{\r\n    .input-label{\r\n        font-size: 14px;\r\n    }\r\n    .css-9ddj71-MuiInputBase-root-MuiOutlinedInput-root{\r\n        width:200px;\r\n        background-color:white\r\n    }\r\n    .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input {\r\n        height: 0px !important;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
